import {broadcastService} from "../../../services/broadcast.service";

export default {
    async getListBroadCast({dispatch, commit}, data) {
        return await broadcastService.getListBroadcast(data)
            .then(response => {
                if (response.success && response.data) {
                    commit('SET_BROADCAST', response.data)
                    // dispatch("alertSuccess", response.message, { root: true });
                    return Promise.resolve(response.data);
                } else {
                    commit('SET_BROADCAST', [])
                    dispatch("alertError", response.message, { root: true });
                }

            }).catch(error =>{
                commit('SET_MAIL_BOX', [])
                dispatch("alertError", error, { root: true });
                return Promise.reject(false);
            })
    },
    async getListMailSendByBroadcastId({dispatch, commit}, data) {
        return await broadcastService.getListMailSendByBroadcastId(data)
            .then(response => {
                if (response.success && response.data) {
                   commit('SET_BROADCAST', response.data)
                    commit('SET_INFO_DB', { totalPage: response.data.data.last_page, totalRow: response.data.data.total })
                    return Promise.resolve(response.data);
                } else {
                   commit('SET_BROADCAST', [])
                    dispatch("alertError", response.message, { root: true });
                }
            }).catch(error =>{
                commit('SET_BROADCAST', [])
                dispatch("alertError", error, { root: true });
                return Promise.reject(false);
            })
    },
    async exportMailSend({dispatch, commit}, data) {
        return await broadcastService.exportMailSend(data)
            .then(response => {
                if (response.success && response.data) {
                    return Promise.resolve(response.data);
                } else {
                    dispatch("alertError", response.message, { root: true });
                }
            }).catch(error =>{
                dispatch("alertError", error, { root: true });
                return Promise.reject(false);
            })
    },

}